import { convertPersianToGregorian } from '@/common/utils/convertPersianToGregorian';

export const validateNotFutureDate = (value: string) => {
  if (!value) return true;
  const today = new Date().toISOString().split('T')[0];
  const inputDate = convertPersianToGregorian(value);

  if (inputDate > today) {
    return 'تاریخ نمی‌تواند بعد از امروز باشد';
  }

  return true;
};
export const validateNotPastDate = (value: string) => {
  if (!value) return true;
  const today = new Date().toISOString().split('T')[0];
  const inputDate = convertPersianToGregorian(value);

  if (inputDate < today) {
    return 'تاریخ نمی‌تواند قبل از امروز باشد';
  }

  return true;
};

export const validateCurrentDateNotBiggerThanTargetDate = (
  value: string,
  targetDate: string,
  targetDateName: string,
  currnetDateName: string,
) => {
  if (!value) return true;
  const inputDate = convertPersianToGregorian(value);
  const target = convertPersianToGregorian(targetDate);

  if (inputDate > target) {
    return `تاریخ ${currnetDateName} نمیتواند از ${targetDateName} بزرگتر باشد`;
  }

  return true;
};
